<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/Foreword">Foreword, by Mike Carey</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1">1. From Rags: 1863–1882</a></p>
<p class="toc"><a href="#/Chapter2">2. Emerson’s Empire Begins: 1882–1895</a></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. Cold Cash: 1896–1900</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. Salt Bandwagon: 1901–1905</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Soda Ash Is Where It’s At: 1906–1910</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. The Very Fair Senator: 1911–1916</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. Boxes, Bags and Trolleys: 1917–1920</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">8. The Affluent Life: 1921–1922</span></p>
<p class="toc"><span href="#/Chapter9" title="Link target outside of Sample">9. Soaring to New Highs and Digging to New Lows: 1923–1931</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">10. The Final Years: 1931–1935</span></p>
<p class="toc1"><span href="#/Careyisms" title="Link target outside of Sample">Careyisms</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0cfa4c14